export const onlineCarrierType = {
  maersk: "maersk",
  cma: "cma",
  one: "one",
  msc: "msc",
  hapagLloyd: "hapag-lloyd",
  cosco: "cosco",
  other: "other",
};
